import React, { Component } from "react";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import withWidth from "@material-ui/core/withWidth";
import { Scrollbars } from "react-custom-scrollbars";

import Dialog from "@material-ui/core/Dialog";
import Grid from "@material-ui/core/Grid";
import CloseIcon from "@material-ui/icons/Close";
import { withStyles } from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";
import {
  THEME_COLORS,
  QUICK_TAB_OPTIONS,
  FILTER_OPTIONS
} from "../../utils/Constants";
import { setFilters } from "../../store/actionCreators/filters";
import { reduceMenuList } from "../../store/actionCreators/menuList";
import { Checkbox, MenuItem } from "@material-ui/core";
import { FormControlLabel } from "@material-ui/core";
import { MuiThemeProvider } from "@material-ui/core";
import foodbookTheme from "../../hoc/Theme";
import { setAllergens } from "../../store/actionCreators/allergens";

const styles = theme => ({
  root: {
    maxWidth: "450px",
    width: "100%",
    height: "100%",
    maxHeight: "400px",
    borderRadius: "10px",
    position: "relative",
    margin: "10px"
  },
  scrollPaper: {
    zIndex: 9999
  },
  Header: {
    backgroundColor: "#F0F0F0",
    padding: "10px 20px",
    // position: "sticky",
    top: "0px",
    left: "0px"
  },
  Container: {
    width: "100%",
    height: "100%",
    "-webkit-overflow-scrolling": "touch",
    overflowY: "auto",
    position: "relative"
  },
  DropdownContainerStyles: {
    width: "250px",
    backgroundColor: "white",
    boxShadow: "0px 0px 10px 1px rgba(0,0,0,0.75)",
    position: "absolute",
    cursor: "initial",
    textTransform: "none"
  },
  MenuItemWrapper: {
    paddingBottom: "8px",
    paddingTop: "8px"
  },
  FullWidthContainer: {
    paddingRight: "0px",
    paddingLeft: "0px"
  },
  FullWidthLabel: {
    width: "100%",
    margin: "0px",
    paddingRight: "16px",
    position: "relative"
  },
  LabelStyles: {
    position: "absolute",
    left: "100px"
  },
  AllergenLabel: {
    position: "absolute",
    left: "50px",
    width: "calc(100% - 60px)",
    whiteSpace: "normal"
  },
  SubHeader: {
    padding: "10px 0px",
    background: "#F37020",
    margin: "0px",
    color: "white"
  }
});

const PANEL_OPTIONS = ["Type", "Allergens"];

class FilterDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPanel: PANEL_OPTIONS[0]
    };
  }

  isChecked = panel => option => {
    const { filters, allergens } = this.props;
    let found = false;

    if (panel === PANEL_OPTIONS[0]) {
      found = filters.some(currentOption => currentOption === option);
    }

    if (panel === PANEL_OPTIONS[1]) {
      found = allergens.some(currentOption => currentOption === option);
    }
    return found;
  };

  handleCheckBoxChange = type => option => event => {
    const {
      immutableMenuList,
      immutableSubMenu,
      currentSession,
      filters,
      servingTime,
      searchText,
      searchId,
      restaurantIsAlive,
      selectedDate,
      isBuffet,
      allergens
    } = this.props;

    let newFilters = [...filters];
    if (type === PANEL_OPTIONS[0]) {
      if (!newFilters.includes(option)) {
        newFilters.push(option);
      } else {
        let index = newFilters.indexOf(option);
        if (index > -1) {
          newFilters.splice(index, 1);
        }
      }
    }

    let newAllergens = [...allergens];
    if (type === PANEL_OPTIONS[1]) {
      if (!newAllergens.includes(option)) {
        newAllergens.push(option);
      } else {
        let index = newAllergens.indexOf(option);
        if (index > -1) {
          newAllergens.splice(index, 1);
        }
      }
    }

    this.props.changeFilter(immutableMenuList, {
      immutableSubMenu,
      selectedDate,
      searchText,
      servingTime,
      currentSession,
      restaurantIsAlive,
      searchId,
      filters: newFilters,
      isBuffet,
      allergens: newAllergens
    });
  };

  changePanel = panel => () => {
    this.setState({ currentPanel: panel });
  };

  render() {
    const { classes, open, immutableAllergens, width } = this.props;
    const {
      root,
      scrollPaper,
      Header,
      Container,
      DropdownContainerStyles,
      FullWidthContainer,
      FullWidthLabel,
      LabelStyles,
      SubHeader,
      AllergenLabel
    } = classes;

    const { currentPanel } = this.state;
    // let isMobile = width === "xs" || width === "sm" || false;

    return (
      <Dialog
        onClose={this.props.closeMenu}
        open={open}
        classes={{ paper: root, scrollPaper: scrollPaper }}
      >
        <Grid container className={Header}>
          <Grid item xs style={{ fontWeight: "bold" }}>
            Filter
          </Grid>
          <Grid
            item
            style={{ cursor: "pointer" }}
            onClick={this.props.closeMenu}
          >
            <CloseIcon />
          </Grid>
        </Grid>
        <MuiThemeProvider theme={foodbookTheme}>
          <div className={Container}>
            <Grid container style={{ position: "relative", height: "100%" }}>
              <Grid item xs={4}>
                {PANEL_OPTIONS.map(option => {
                  if (
                    option === "Allergens" &&
                    immutableAllergens.length === 0
                  ) {
                    return null;
                  }

                  return (
                    <MenuItem
                      key={option}
                      style={{
                        paddingLeft: "10px",
                        whiteSpace: "normal",
                        backgroundColor:
                          currentPanel === option ? "#F37020" : "white",
                        color: currentPanel === option ? "white" : "black"
                      }}
                      className={FullWidthContainer}
                      onClick={this.changePanel(option)}
                    >
                      {option}
                    </MenuItem>
                  );
                })}
              </Grid>
              <Grid
                item
                xs={8}
                style={{
                  height: "100%",
                  borderLeft: "1px solid black",
                  position: "relative"
                }}
              >
                <Scrollbars style={{ width: "100%", height: "100%" }}>
                  {currentPanel === PANEL_OPTIONS[0] &&
                    FILTER_OPTIONS.map(filterOption => (
                      <MenuItem
                        key={filterOption.label}
                        className={FullWidthContainer}
                      >
                        <FormControlLabel
                          className={FullWidthLabel}
                          classes={{ label: AllergenLabel }}
                          control={
                            <Checkbox
                              color="primary"
                              checked={this.isChecked(PANEL_OPTIONS[0])(
                                filterOption.option
                              )}
                              onClick={this.handleCheckBoxChange(
                                PANEL_OPTIONS[0]
                              )(filterOption.option)}
                            />
                          }
                          label={filterOption.label}
                        />
                      </MenuItem>
                    ))}
                  {currentPanel === PANEL_OPTIONS[1] &&
                    immutableAllergens.map(allergenOption => (
                      <MenuItem
                        key={allergenOption}
                        className={FullWidthContainer}
                      >
                        <FormControlLabel
                          className={FullWidthLabel}
                          classes={{ label: AllergenLabel }}
                          control={
                            <Checkbox
                              color="primary"
                              checked={this.isChecked(PANEL_OPTIONS[1])(
                                allergenOption
                              )}
                              onClick={this.handleCheckBoxChange(
                                PANEL_OPTIONS[1]
                              )(allergenOption)}
                            />
                          }
                          label={allergenOption}
                        />
                      </MenuItem>
                    ))}
                </Scrollbars>
              </Grid>
            </Grid>
          </div>
        </MuiThemeProvider>
      </Dialog>
    );
  }
}

const mapStateToProps = state => {
  return {
    immutableAllergens: state.immutableAllergens,
    allergens: state.allergens,
    filters: state.filters,
    immutableMenuList: state.immutableMenuList,
    immutableSubMenu: state.immutableSubMenu,
    filters: state.filters,
    searchText: state.searchText,
    searchId: state.searchId,
    selectedDate: state.selectedDate,
    currentSession: state.currentSession,
    isBuffet: ((state.currentRestaurantDetails || {}).restextras || {})
      .isbuffet,
    restaurantIsAlive: (state.currentRestaurantDetails || {}).resturantalive,
    servingTime: (state.currentRestaurantDetails || {}).servingtime
  };
};

const mapDispatchToProps = dispatch => {
  return {
    changeFilter: (centralData, options) => {
      dispatch(setFilters(options.filters));
      dispatch(setAllergens(options.allergens));
      dispatch(reduceMenuList(centralData, options));
    }
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withWidth()(withStyles(styles)(FilterDropdown)))
);



// WEBPACK FOOTER //
// ./src/components/Dashboard/FilterDropdown.js